import {
  ALLOWED_EVENT_TYPES_LOAD,
  ALLOWED_EVENT_TYPES_LOAD_SUCCESS,
  ALLOWED_EVENT_TYPES_LOAD_FAIL,
} from "./action";

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [],
  extraData: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ALLOWED_EVENT_TYPES_LOAD:
      return {
        ...state,
        loading: true,
      };
    case ALLOWED_EVENT_TYPES_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: "This is extra info..........",
      };
    case ALLOWED_EVENT_TYPES_LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
}
